module.exports = __webpack_public_path__ + "static/app-panel-background-74541104e49878cdc4569593ee402b3b.png";